import { createFileRoute } from "@tanstack/react-router";

import GatewayCredentialsPage from "@/features/dashboard/pages/gateway-credentials";

export const Route = createFileRoute("/(app)/dashboard/gateway/credentials")({
  component: () => <GatewayCredentialsPage />,
});
